export enum ProficiencyLevelsEnum {
  FUNDAMENTAL = 'fundamental',
  INTERMEDIATE = 'intermediate',
  ADVANCED = 'advanced',
}

export enum SeniorityLevelEnum {
  JUNIOR = 'Entry-Level',
  MID = 'Mid-Level',
  SENIOR = 'Senior-Level',
}
